<template>
	<div class="main-contents">
		<div class="contents">
			<div class="contents_body">
				<div class="tit">
					<span>회원가입</span><br/>
					IT 프로 얼라이언스 플랫폼, 그레이트 프로에 오신 걸 환영합니다.
				</div>

				<div class="joinbox">
					<div>
						<p>프로젝트를 찾는다면, 지금 가입하세요</p>
						<div class="mem-reg-bt01" @click="pageMove('11')">
							<span>IT프로 회원 가입하기</span>
						</div>
						<div class="kakao-btn" @click="goKakao">
							<img src="/images/mem/kakao_symbol.png" alt="카카오로 회원 가입하기">
							<span>카카오로 회원 가입하기</span>
						</div>
					</div>
					<div class="mt-10">
						<p>IT 프로와 성공기회를 원한다면, 지금 가입하세요</p>						
						<div class="mem-reg-bt02" @click="pageMove('31')">
							<span>파트너사 회원 가입하기</span>
						</div>
						<div class="mem-reg-bt02" @click="pageMove('22')">
							<span>클라이언트 회원 가입하기</span>
						</div>
					</div>
				</div>				
			</div>
		</div>
	</div><!-- //main-contents -->
</template>

<script>
import { accountMeta } from '@/utils/meta';

export default {
	metaInfo : accountMeta,
	data() {
		return {

		}
	},
	methods : {

		goKakao() {
			this.$.kakaoSync(this, function(this_obj, res) {
				this_obj.code = res;
				this_obj.accountSync();
			});
		},

		accountSync() {
			this.$.httpPost('/api/mem/kakao/accountSync', {code : this.code})
				.then(res => {
					this.userDstic = res.data.userDstic;

					if(this.userDstic == 'SYNC' || this.userDstic == 'LOGIN') {
						this.kakaoLogin(res.data.mberSeq);
					}else {
						this.mberInfo = res.data.mberInfo;
						// this.openStipPup(); // 2차 동의 팝업
						this.saveMember();
					}
					
				}).catch((err) => {
					var errResData = err.response.data;
					
					if(errResData && errResData.error_description != '')  {
						alert(errResData.error_description);
					}
				});
		},

		kakaoLogin(mberSeq) {
			this.$.loginKakao(mberSeq, 'kakaoSync', 'tech')
				.then(() => {
					// location.href = location.origin + '/MYP101M01?userDstic='+this.userDstic;
					// 로그인 후 화면 이동 > (25.05.19) 계정별 마이페이지에서 메인화면으로 변경
					location.href = "/?userDstic="+ this.userDstic;
				})
				.catch(this.$.httpErrorCommon);
		},

		saveMember() {
			this.$.httpPost('/api/mem/insertMberInfo', {mberInfo: this.mberInfo}, '')
				.then(res => {
					if(res.data.resultCode == "000"){
						if(res.data.data.mberSeq) {
							this.kakaoLogin(res.data.data.mberSeq);
						}
					}else {
						alert(res.data.message);
					}
				})
				.catch(err => {
					alert(err.response.data.error_description);
				});
		},

		pageMove(mberDiv) {
			var sendData = {
				mberDivCd : mberDiv
			}

			var name = 'MEM004M01';
			// if(mberDiv == '2') name = 'MEM003M02';

			this.$router.push({name : name, params : {forwardData : sendData}});
		}
	}
}
</script>